export default class ResponseError extends Error {
    response: Response;
}


// WEBPACK FOOTER //
// ./app/client/_data/models/ResponseError.ts